<div *ngIf="isStyle1" id="personas"></div>
<div class="tabs tabs--{{block.data.style || 'style1'}}">
  <mat-tab-group class="tabs_group" *ngIf="isStyle1" [disableRipple]="true" [ngClass]="'tabs_group--active-index-' + activeTabIndex" (selectedTabChange)="tabChange($event)">
    <mat-tab *ngFor="let block of block.content trackBy: trackByFn; let index = index;">

      <ng-template mat-tab-label>
        <div class="tabs__header" [ngClass]="{'tabs_group--prev-active': prevSelectedTabs[index]}" [ngStyle]="{'background-image': block.data.image && isStyle1 ? 'url(' + block.data.image + ')' : null}"></div>
        <div class="tabs__header-title">
          <h5>Meet <br class="d-block d-sm-none">{{block.data.headerText}}.</h5>
        </div>
      </ng-template>

      <div class="tabs__content {{block.data.title}} {{block.data.visibility}}" [ngClass]="{container: block.data.columnsSmall == 'full' ||  block.data.columnsNormal == 'full', 'col-sm-12': block.data.columnsSmall == 'full', 'col-md-12': block.data.columnsNormal == 'full'}" [ngStyle]="{padding: block.data.padding, margin: block.data.margin }">
        <core-block *ngFor="let subBlock of block.content" [block]="subBlock" class="subWidget {{subBlock.data.class}}"></core-block>
      </div>
    </mat-tab>
  </mat-tab-group>
  <mat-tab-group class="tabs_group" *ngIf="isStyle2" [disableRipple]="true" [ngClass]="'tabs_group--active-index-' + activeTabIndex" (selectedTabChange)="tabChange($event)">
    <mat-tab *ngFor="let block of block.content trackBy: trackByFn; let index = index;">
      <ng-template mat-tab-label>
        <div class="tabs__header" [ngClass]="{'tabs_group--prev-active': prevSelectedTabs[index]}" [ngStyle]="{'background-image': block.data.image && isStyle1 ? 'url(' + block.data.image + ')' : null}">{{block.data.headerText}}</div>
      </ng-template>
      <div class="tabs__content {{block.data.title}} {{block.data.visibility}}" [ngClass]="{container: block.data.columnsSmall == 'full' ||  block.data.columnsNormal == 'full', 'col-sm-12': block.data.columnsSmall == 'full', 'col-md-12': block.data.columnsNormal == 'full'}" [ngStyle]="{padding: block.data.padding, margin: block.data.margin }">
        <core-block *ngFor="let subBlock of block.content" [block]="subBlock" class="subWidget {{subBlock.data.class}}"></core-block>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
